import React from 'react';
import { Check, MessageCircleQuestion, Pencil, Pin, RefreshCw, Repeat, Sparkles } from 'lucide-react';
import { Button } from '../ui';
import { AIState, stateOfError } from './AIStates';
import './ErrorAnalysisDraft.css';

/**
 * Caderno de erros (2d): a IA preenche motivo, regra e 2 variações como rascunho editável.
 * Salvar grava nos campos que já existem (errorReason, simpleRule, variation1/2).
 */
export function ErrorAnalysisDraft({ draft, onRetry, onDiscard, onSave, onEdit }) {
  if (draft.loading) {
    return (
      <div className="ead ead--loading">
        <div className="ai-thinking"><span className="ai-dots" aria-hidden="true"><i /><i /><i /></span>Analisando o erro...</div>
      </div>
    );
  }
  if (draft.error) {
    return (
      <div className="ead ead--error">
        <AIState kind={stateOfError(draft.error.code)} message={draft.error.message} onRetry={onRetry} compact />
        <button type="button" className="ead__ghost" onClick={onDiscard}>Fechar</button>
      </div>
    );
  }
  const d = draft.data;
  const rows = [
    { icon: MessageCircleQuestion, label: 'Motivo', text: d.errorReason },
    { icon: Pin, label: 'Regra', text: d.simpleRule },
    { icon: Repeat, label: 'Variações', text: [d.variation1, d.variation2].filter(Boolean).map((v, i) => `${i + 1}) ${v}`).join(' · ') },
  ];
  return (
    <div className="ead">
      <div className="ead__head">
        <Sparkles size={14} aria-hidden="true" />
        <strong>Rascunho da IA</strong>
        <span>revise antes de salvar</span>
        <button type="button" className="ead__ghost" onClick={onRetry}><RefreshCw size={13} aria-hidden="true" />Refazer</button>
      </div>
      {rows.map(r => (
        <div key={r.label} className="ead__row">
          <span className="ead__label"><r.icon size={14} aria-hidden="true" />{r.label}</span>
          <p>{r.text}</p>
          <button type="button" className="ss-iconbtn" onClick={() => onEdit(d)} aria-label={`Editar ${r.label.toLowerCase()}`}><Pencil size={14} aria-hidden="true" /></button>
        </div>
      ))}
      <div className="ead__foot">
        <span>As variações viram questões no "Simulado dos meus erros".</span>
        <button type="button" className="ead__ghost" onClick={onDiscard}>Descartar</button>
        <Button size="sm" icon={Check} onClick={() => onSave(d)}>Salvar análise</Button>
      </div>
    </div>
  );
}
